import { IApiError } from '@frontend/request';

import {
  IAccountStatistics,
  IDailyStatistics,
  IProfitsStatistics,
  IStatisticsProfitsParams,
  statisticsAPI
} from '@aqx-core/common/api/statistics';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class StatisticsAPIController {
  private statisticsAccountAC?: AbortController;
  private statisticsDailyAC?: AbortController;
  private statisticsProfitsAC?: AbortController;

  public getAccountStatistics = async (callbacks: IAPIControllerCallbacks<IAccountStatistics>) => {
    try {
      this.statisticsAccountAC?.abort();
      this.statisticsAccountAC = new AbortController();

      const { result } = await statisticsAPI.account(this.statisticsAccountAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getDailyStatistics = async (callbacks: IAPIControllerCallbacks<IDailyStatistics>) => {
    try {
      this.statisticsDailyAC?.abort();
      this.statisticsDailyAC = new AbortController();

      const { result } = await statisticsAPI.daily(this.statisticsDailyAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getProfitStatistics = async (
    params: IStatisticsProfitsParams,
    callbacks: IAPIControllerCallbacks<IProfitsStatistics[]>
  ) => {
    try {
      this.statisticsProfitsAC?.abort();
      this.statisticsProfitsAC = new AbortController();

      const { result } = await statisticsAPI.profits(params, this.statisticsProfitsAC.signal);
      callbacks.onSuccess(result ?? []);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const statisticsAPIController = new StatisticsAPIController();
